if (!customElements.get('clamp-block')) {
  customElements.define('clamp-block', class ClampBlock extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.clamp-block__toggle');
      this.content = this.querySelector('.clamp-block__content > *:last-child');

      this.checkOverflow();

      this.toggle.addEventListener('click', () => {
        this.classList.toggle('clamp-block--is-clamped');
        let newText = this.toggle.dataset.text;
        let oldText = this.toggle.innerText;
        this.toggle.innerText = newText;
        this.toggle.dataset.text = oldText;
      });
    }

    checkOverflow() {
      // Update the visibility of the toggle button based on content overflow
      const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
      this.toggle.style.display = isOverflowing ? 'inline-block' : 'none';
    }
  });
}
